import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  faChevronDoubleLeft,
  faChevronDoubleRight,
} from "@fortawesome/pro-solid-svg-icons";

import DinesLogoWithTitle from "@/components/Logos/DinesLogoWithTitle";
import { cn } from "@/utils/css";
import Icon from "@/components/library/Icon";

interface ISideBarTitle {
  collapseSidebar: boolean;
  setCollapseSidebar: (collapseSidebar: boolean) => void;
  menuOpen: boolean;
  toggleMenu: () => void;
}

const SideBarTitle: React.FC<ISideBarTitle> = ({
  collapseSidebar,
  setCollapseSidebar,
  menuOpen,
  toggleMenu,
}) => (
  <div
    role="button"
    tabIndex={0}
    className={cn(
      collapseSidebar
        ? "mb-3 px-8 md:mx-auto md:mb-0 md:justify-center md:px-0"
        : "mb-3 px-8",
      "sticky top-0 mt-4 flex w-full items-center justify-between border-none bg-dines-purple-darkest pt-4 pb-1 outline-none focus:outline-none",
    )}
    onClick={() => setCollapseSidebar(!collapseSidebar)}
    onKeyDown={() => setCollapseSidebar(!collapseSidebar)}
  >
    <div className={`${collapseSidebar ? "md:hidden" : "flex"}`}>
      <DinesLogoWithTitle />
    </div>

    <div
      className={cn(
        "hidden md:my-4 md:flex",
        collapseSidebar
          ? "hidden flex-col items-center space-y-4 md:flex"
          : "hidden md:block",
      )}
    >
      <Icon
        icon={collapseSidebar ? faChevronDoubleRight : faChevronDoubleLeft}
        size="lg"
        className={`cursor-pointer ${collapseSidebar ? "md:mb-4" : "mb-0"}`}
      />
    </div>
    {menuOpen && (
      <div className=" md:hidden ">
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            toggleMenu();
          }}
        >
          <Icon icon={menuOpen ? faTimes : faBars} size="lg" />
        </button>
      </div>
    )}
  </div>
);

export default SideBarTitle;
